module.exports = __webpack_public_path__ + "media/images/product/d1-41044488fe463349570147bc4b220b58.png";